export enum TreeDirection {
  HORIZONTAL = 'LR',
  VERTICAL = 'TB',
}

export enum PanelPosition {
  TOP_LEFT = 'top-left',
  TOP_CENTER = 'top-center',
  TOP_RIGHT = 'top-right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_CENTER = 'bottom-center',
  BOTTOM_RIGHT = 'bottom-right',
}

export enum EditOrganisationMapEnum {
  EDIT_MAP_TITLE = 'Edit map',
  EDIT_MAP_INFO = `Please add and map the organization based on the hierarchy and edit
  the organizational boundaries accordingly.`,
  EDIT_MAP_PARENT_INFO = ` Parent cannot be deleted, add another parent to delete it.`,
  DUPLICATE_MAP_BUTTON_TITLE = 'Duplicate map from particular year',
  ORGANISATIONAL_BOUNDARY_LABEL = 'Organizational boundary',
  DELETE_MENU_TITLE = 'Delete',
  RESET_BUTTON_TEXT = 'Reset',
  SAVE_BUTTON_TEXT = 'Save this year',
  DELETE_YEAR_TEXT = `Are you sure you want to delete the organization map for the year?`,
}

export enum OrgBoundaryEnum {
  Equity = 'Equity',
  Financial = 'Financial',
  Operational = 'Operational',
}

export enum OrganisationMenu {
  DELETE = 'delete',
}

export enum OrganisationMapNodeDimensions {
  WIDTH = 380,
  HEIGHT = 75,
}

export enum OrganisationMapMode {
  VIEW = 'view',
  EDIT = 'edit',
}

export enum NewNodeType {
  PARENT = 'parent',
  CHILD = 'child',
}

export enum NewOrganisationModalEnum {
  CLOSE_TEXT = 'Back',
  PROCEED_TEXT = 'Next',
  SUBMIT_TEXT = 'Submit',
  NEXT_TEXT = 'Next',
  DROPDOWN_FIELD_NAME = 'organization',
  DROPDOWN_FIELD_PLACEHOLDER = 'Choose from the list of organization',
  ADD_ORGANIZATION_TEXT = 'Add organization',
  SECTOR_FIELD_NAME = 'sector.id',
  COMPANY_TYPE_FIELD_NAME = 'companyType.id',
  SIZE_FIELD_NAME = 'size.id',
  ORGANIZATION_DETAILS = 'Organization details',
  REPORTING_DETAILS = 'Reporting details',
  ORGANISATIONAL_BOUNDARY_FIELD_NAME = 'company.organizationalBoundary',
  NAME_FIELD = 'name',
  ORGANIZATION_SHARE = 'organisationYearWise.organizationShare',
  REPORTING_MONTH = 'company.reportingMonth',
  BASELINE_YEAR = 'company.baselineYear',
  RECALCULATION_THRESHOLD = 'company.recalculationThreshold',
}
